interface ILeapHomeContainerProps {
  content: JSX.Element;
}

const CircularEconomyHomeContainer = ({ content }: ILeapHomeContainerProps) => (
  <div>{content}</div>
);

export default CircularEconomyHomeContainer;
